import { Leaf, PartyPopper, Clapperboard, Laptop } from "lucide-react";

export const TIERS = [
  {
    key: "comfort", name: "Comfort", car: "Hybride sedan", seats: 3, img: "/cars/comfort.jpg",
    perks: ["Stil en zuinig", "Ruim voor 3 personen"],
  },
  {
    key: "premium", name: "Premium", car: "Mercedes E-Klasse of BMW 5", seats: 4, img: "/cars/premium.jpg",
    perks: ["Kies je thema", "Lederen interieur"], badge: "Meest gekozen",
  },
  {
    key: "bovenklasse", name: "Bovenklasse", car: "Mercedes S-Klasse of Maybach", seats: 4, img: "/cars/bovenklasse.jpg",
    perks: ["Kies je thema", "Topklasse limousine"],
  },
];

export const VAN = {
  key: "van", name: "Van", car: "Mercedes V-Klasse of vergelijkbaar", seats: 8, img: "/cars/van.jpg",
  perks: ["Tot 8 personen", "Ruimte voor bagage"],
};

export const TIERS_WITH_THEMES = new Set(["premium", "bovenklasse"]);

export const THEMES = [
  {
    key: "relax", name: "Relax", icon: Leaf, color: "var(--theme-relax)", accent: "#1F7A57",
    line: "Zachte muziek, rustig rijden.",
    prefs: { music: "jazz", temperature: "normaal", conversation: "stil" },
  },
  {
    key: "party", name: "Party", icon: PartyPopper, color: "var(--theme-party)", accent: "#6B46C1",
    line: "Upbeat playlist, gezellige rit.",
    prefs: { music: "pop", temperature: "koel", conversation: "gezellig" },
  },
  {
    key: "film", name: "Film", icon: Clapperboard, color: "var(--theme-film)", accent: "#2B5FB8",
    line: "Geen muziek, stil. Kijk ongestoord.",
    prefs: { music: "geen", temperature: "normaal", conversation: "stil" },
  },
  {
    key: "focus", name: "Focus", icon: Laptop, color: "var(--theme-focus)", accent: "#455A64",
    line: "Stilte om te werken of te bellen.",
    prefs: { music: "geen", temperature: "koel", conversation: "stil" },
  },
];

export const tierMeta = (key) => (key === "van" ? VAN : TIERS.find((t) => t.key === key) || TIERS[0]);
export const themeMeta = (key) => THEMES.find((t) => t.key === key) || null;

export const effectiveTier = (state) => (state.passengers >= 5 ? "van" : state.tier);

export const priceFor = (quote, tier) => {
  if (!quote) return null;
  if (tier === "van") return quote.price_eur;
  return quote.all_tier_prices?.[tier]?.price_eur ?? null;
};

export const fmtEur = (n) =>
  n == null ? "—" : new Intl.NumberFormat("nl-NL", { style: "currency", currency: "EUR" }).format(n);

export const pickupIso = (state) =>
  state.when === "later" && state.scheduledAt ? new Date(state.scheduledAt).toISOString() : new Date().toISOString();

export const fmtWhen = (state) => {
  if (state.when !== "later" || !state.scheduledAt) return "Zo snel mogelijk";
  return fmtDate(new Date(state.scheduledAt).toISOString());
};

export const fmtDate = (iso) =>
  new Date(iso).toLocaleString("nl-NL", { weekday: "short", day: "numeric", month: "short", hour: "2-digit", minute: "2-digit" });

export const fmtDuration = (sec) => {
  if (!sec) return "";
  const m = Math.round(sec / 60);
  return m < 60 ? `${m} min` : `${Math.floor(m / 60)} u ${m % 60} min`;
};

export const labelStyle = {
  display: "block",
  marginBottom: 8,
  fontSize: 15,
  color: "var(--sw-ink-soft)",
  fontFamily: "'Bricolage Grotesque', sans-serif",
  fontWeight: 400,
};

export const StepTitle = ({ title, sub }) => (
  <div style={{ marginBottom: 20 }}>
    <h1 className="sw-step-title">{title}</h1>
    {sub && <p className="sw-step-sub">{sub}</p>}
  </div>
);
